import { css } from "styled-system/css";

export default function Disclaimer() {
  return (
    <div class={css({
      position: 'relative',
      width: '100%',
      bg: 'bg.emphasized',
      height: 6 // Reserves exactly this much space at the bottom of your page
    })}>
      <p class={css({
        p: '1',
        lineHeight: '18px',
        fontSize: '10px',
        textAlign: 'center',
        px: 6,

        // Anchors to the bottom of the wrapper
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,

        // Initial hidden state
        maxHeight: 6,
        overflow: 'hidden',

        // Smooth slide-up transition
        transition: 'max-height 0.3s ease-in-out',
        bg: 'bg.emphasized',

        // Hover state expands upwards
        _hover: {
          maxHeight: '150px',
        }
      })}>
        Disclaimer: All Setups and Chat discussions are for educational purposes only and do not constitute financial advice. Nothing is a recommendation to buy or sell. Do your own research and consult a licensed advisor.
      </p>
    </div>
  )
}
